const getId = (length = 8): string => `${Math.random().toString(36).substring(2, length + 2)}`;

export default getId;
